var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "", "align-end": "" } },
    [
      _c("list-edition-toolbar", {
        attrs: { buttons: _vm.toolbarButtons },
        on: {
          add: function($event) {
            return _vm.startEditingItem(null, "create")
          }
        }
      }),
      _vm._v(" "),
      _c("checklist-table", {
        attrs: {
          "edition-disabled": _vm.editionDisabled,
          allRows: _vm.rowsPerPage,
          checklist: _vm.editedChecklist
        },
        on: {
          editItem: function($event) {
            return _vm.startEditingItem($event, "edit")
          },
          removeItem: _vm.tryRemoveItem
        }
      }),
      _vm._v(" "),
      _vm.itemEditionDialog
        ? _c("checklist-item-edition", {
            attrs: {
              open: _vm.itemEditionDialog,
              "original-item": _vm.itemToEdit,
              "item-index": _vm.itemIndex,
              "stored-items": _vm.originalChecklistItems
            },
            on: {
              close: _vm.closeItemEdition,
              add: _vm.addItem,
              edit: _vm.editItem
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.itemDeleteDialog,
          title: _vm.$t("DeleteItem"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.itemToEdit.label + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.itemDeleteDialog = false
          },
          secondaryAction: _vm.removeItem
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b1aebcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1aebcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/Checklist.vue
// module id = null
// module chunks = 